import React from 'react';

type IconProps = {
  size?: number; // Size of the icon
  className?: string; // Additional custom classes
};

const PillIcon: React.FC<IconProps> = ({ size = 22, className = '' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3795 10.4997L11.1662 17.713C9.45018 19.429 6.66959 19.429 4.95354 17.713V17.713C3.23749 15.9969 3.23749 13.2163 4.95354 11.5003L12.1668 4.28704C13.8828 2.57099 16.6634 2.57099 18.3795 4.28704V4.28704C20.0955 6.00309 20.0955 8.78513 18.3795 10.4997Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.58496 7.9209L14.7511 14.0871"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PillIcon;
